<template>
  <article class="teaser order-teaser" :class="{'opacity-50' : !order.item_id, 'cancelled' : status === 'Annullato'}" v-if="order">
    <h4>
      Ordine #{{order.id}}
      <time>{{timeFormatter(order.timestamp_emissione)}}</time>
      <span v-if="status === 'Annullato'" class="cancel-badge">Annullato</span>
      <button v-if="status === '0 -'" class="cancel-btn" @click.prevent="toggleCancelOverlay" title="Annulla ordine">✕</button>
    </h4>
    <div class="cancel-overlay" v-if="cancelToggle">
      <h6 v-if="!loading">Vuoi DAVVERO annullare l'ordine <b>#{{order.id}}</b>? L'operazione è irreversibile.</h6>
      <a v-if="!loading" class="ok" href="#" @click.prevent="cancelOrder">Sì, annulla l'ordine</a>
      <a v-if="!loading" class="not-ok" href="#" @click.prevent="toggleCancelOverlay">No, torna indietro</a>
      <v-icon v-if="loading" name="fa-spinner" class="animate-spin text-gray-400 w-20" />
    </div>
    <h5 :class="{'text-red-500' : !order.item_id}">
      ‣ <b>{{order.agreement_no}}</b> | P.V. <b>{{order.pdv_id}}</b> - <small
        class="text-xs">{{getPvName(order.pdv_id)}}</small>
    </h5>
    <hr>
    <ul v-if="order.item_id">
      <li>
        <ul>
          <li><label class="font-bold">‣ Articolo: </label><span>{{order.item_id}}</span></li>
          <li v-if="desc"><label>Descrizione: </label><span class="text-xs truncate leading-6 pl-2"
              :title="desc">{{desc}}</span></li>
          <li><label>Quantità: </label><span>{{order.quantity}}</span></li>
          <li v-if="shownFields.includes('loyalty_card') && order.loyalty_card"><label>N° Carta:
            </label><span>{{order.loyalty_card}}</span></li>
          <li>
            <label>Spedizione: </label><span class="text-xs">{{order.email ? order.email : '-'}}<button v-if="order.email && status === '20 Inviato'" class="send-again" @click.prevent="toggleMailOverlay">✉</button></span>
            <div class="mail-overlay" v-if="mailToggle">
              <h6 v-if="!loading">Vuoi DAVVERO spedire di nuovo il Voucher all'indirizzo <b>{{order.email}}</b>? (azione irreversibile)</h6>
              <a v-if="!loading" class="ok" href="#" @click.prevent="sendAgain">Sì, confermo</a>
              <a v-if="!loading" class="not-ok" href="#" @click.prevent="toggleMailOverlay">No, annulla</a>
              <v-icon v-if="loading" name="fa-spinner" class="animate-spin text-gray-400 w-20" />
            </div>
          </li>
          <li v-if="shownFields.includes('customer_firstname') || shownFields.includes('customer_lastname')">
            <label class="mr-2">Dati anagrafici:</label>
            <span v-if="order.customer_firstname || order.customer_lastname" class="text-right text-sm">
              {{order.customer_firstname ? order.customer_firstname : ''}} {{order.customer_lastname ?
              order.customer_lastname : ''}}
            </span>
          </li>
          <li
            v-if="shownFields.includes('customer_business_name')">
            <label>Ragione sociale: </label>
            <span v-if="order.customer_business_name">
              {{order.customer_business_name ? order.customer_business_name : ''}}
            </span>
          </li>
          <li
            v-if="shownFields.includes('customer_client_code')">
            <label>Codice cliente: </label>
            <span v-if="order.customer_client_code">
              {{order.customer_client_code ? order.customer_client_code : ''}}
            </span>
          </li>
          <li
            v-if="shownFields.includes('customer_phone_number')">
            <label>Numero di telefono: </label>
            <span v-if="order.customer_phone_number">
              {{order.customer_phone_number ? order.customer_phone_number : ''}}
            </span>
          </li>
          <li v-if="order.ship_to_street">
            <label class="mr-2">Indirizzo di consegna:</label>
            <span class="text-right text-sm">
              {{order.ship_to_address_name ? order.ship_to_address_name + ' — ' : ''}}{{order.ship_to_street}}, {{order.ship_to_zip_code}} {{order.ship_to_city}} ({{order.ship_to_state ? order.ship_to_state : order.ship_to_country}})
            </span>
          </li>
          <li v-if="order.ship_to_notes">
            <label>Note per il corriere: </label>
            <span>{{order.ship_to_notes}}</span>
          </li>
          <li v-if="order.delivery_status">
            <label>Stato consegna: </label>
            <span>{{order.delivery_status}}</span>
          </li>
          <li v-if="order.delivery_tracking">
            <label>Tracciamento: </label>
            <span><a :href="order.delivery_tracking" target="_blank" rel="noopener noreferrer">Traccia spedizione</a></span>
          </li>
          <li v-if="order.pathapi_delivery_note || order.pathapi_proof_of_delivery">
            <label>Documenti: </label>
            <span class="pdf-links">
              <button v-if="order.pathapi_delivery_note" class="pdf-btn" @click.prevent="openPdf(order.id, 'delivery_note')">DDT</button>
            </span>
            <span class="pdf-links">
              <button v-if="order.pathapi_proof_of_delivery" class="pdf-btn" @click.prevent="openPdf(order.id, 'proof_of_delivery')">Ricevuta di consegna</button>
            </span>
          </li>
        </ul>
      </li>
    </ul>
    <ul v-else>
      <li>
        <ul>
          <li><label class="font-bold text-red-500">‣ ORDINE NON VALIDO</label></li>
        </ul>
      </li>
    </ul>
  </article>
</template>

<script>
import moment from 'moment-timezone'
moment.locale('it')

export default {
  props: ['order', 'desc', 'pvs'],
  data: () => ({
    mailToggle: false,
    cancelToggle: false,
    status: '20 Inviato',
    loading: false
  }),
  methods: {
    async getStatus () {
      await this.$store.dispatch('getStatusOrder', this.order.id)
        .then((rsp) => {
          this.status = rsp.msg
        })
    },
    toggleMailOverlay () {
      this.mailToggle = !this.mailToggle
    },
    toggleCancelOverlay () {
      this.cancelToggle = !this.cancelToggle
    },
    async cancelOrder () {
      this.loading = true
      await this.$store.dispatch('cancelBooking', { id: this.order.id })
        .then((rsp) => {
          this.cancelToggle = false
          this.loading = false
          if (!rsp) {
            const error = true
            const msg = 'Errore durante l\'annullamento: riprovare più tardi.'
            this.emitter.emit('fireAlert', { msg, error })
          } else {
            this.status = 'Annullato'
            const error = false
            const msg = `Ordine #${this.order.id} annullato con successo.`
            this.emitter.emit('fireAlert', { msg, error })
          }
        })
    },
    async sendAgain () {
      this.loading = true
      await this.$store.dispatch('resendVoucher', {
        id: this.order.id
      })
        .then((rsp) => {
          this.mailToggle = false

          if (!rsp) {
            const error = true
            const msg = 'Errore di invio del Voucher: riprovare più tardi.'
            this.emitter.emit('fireAlert', { msg, error })
          } else {
            this.status = null
            const error = false
            const msg = 'Voucher inviato nuovamente all\'indirizzo: ' + this.order.email
            this.emitter.emit('fireAlert', { msg, error })
          }
        })
    },
    timeFormatter (time) {
      return moment.tz(time + 'Z', 'Europe/Rome').format('LLL')
    },
    getPvName (pvCode) {
      const target = this.pvs.filter((el) => {
        return el.code === pvCode
      })

      if (target && target[0]) return '(' + target[0].name + ')'
      else return null
    },
    async openPdf (bookingId, type) {
      const data = this.$store.state.user
      const Authorization = data.token_type + ' ' + data.access_token
      try {
        const rsp = await this.axios.get('/booking/pdf/' + bookingId + '/' + type, {
          headers: { Authorization },
          responseType: 'arraybuffer'
        })
        const blob = new Blob([rsp.data], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (e) {
        const msg = 'Errore nel caricamento del PDF: riprovare più tardi.'
        this.emitter.emit('fireAlert', { msg, error: true })
      }
    }
  },
  computed: {
    shownFields () {
      let extraData = this.$store.state.userData ? this.$store.state.userData.extra_data : null
      if (extraData) {
        extraData = JSON.parse(extraData)
        return extraData.shown_fields ? extraData.shown_fields : []
      } else {
        return []
      }
    }
  },
  async mounted () {
    // console.log('order', this.order)
    await this.getStatus()
  }
}
</script>

<style scoped lang="scss">
  @use "@/assets/scss/teaser-order.scss";
</style>
